import { updatesData } from '@/mocks/home';

const tagColors: Record<string, string> = {
  '剧集更新': 'bg-primary-500/15 text-primary-400 border-primary-500/30',
  '专题上新': 'bg-accent-500/15 text-accent-400 border-accent-500/30',
  '平台公告': 'bg-secondary-500/15 text-secondary-400 border-secondary-500/30',
  '新片上线': 'bg-accent-500/15 text-accent-400 border-accent-500/30',
  'APP更新': 'bg-primary-500/15 text-primary-400 border-primary-500/30',
  '资源扩充': 'bg-secondary-500/15 text-secondary-400 border-secondary-500/30',
};

export default function SectionUpdates() {
  return (
    <section
      id="updates"
      className="py-16 md:py-20 bg-background-50"
    >
      <div className="max-w-[1920px] mx-auto px-4 md:px-6 lg:px-10">
        <div className="text-center mb-8 md:mb-10">
          <span className="inline-block text-xs font-medium text-secondary-400 bg-secondary-500/10 px-3 py-1 rounded-full mb-3">
            最新动态
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">
            最新动态
          </h2>
          <p className="text-sm text-foreground-400 mt-2">平台更新与影视资讯速览</p>
        </div>

        <div className="max-w-2xl mx-auto">
          {/* Timeline */}
          <div className="relative">
            {/* Vertical line */}
            <div className="absolute left-[15px] md:left-[19px] top-2 bottom-2 w-px bg-background-300/60"></div>

            <div className="space-y-5">
              {updatesData.map((item) => {
                const tagClass = tagColors[item.tag] || 'bg-background-300/50 text-foreground-300 border-background-400/30';

                return (
                  <div key={item.content} className="flex gap-4 md:gap-5 items-start group">
                    {/* Dot */}
                    <div className="relative z-10 w-[30px] md:w-[38px] h-[30px] md:h-[38px] shrink-0 rounded-full bg-background-100 border-2 border-primary-500/40 flex items-center justify-center group-hover:border-primary-500 transition-colors">
                      <div className="w-2 h-2 rounded-full bg-primary-500"></div>
                    </div>

                    {/* Content */}
                    <div className="flex-1 bg-background-100 rounded-xl border border-background-300/40 p-4 md:p-5 group-hover:border-background-400/60 transition-all">
                      <div className="flex flex-wrap items-center gap-2 mb-2">
                        <span className={`text-[10px] font-medium px-2 py-0.5 rounded border ${tagClass}`}>
                          {item.tag}
                        </span>
                        <span className="text-[11px] text-foreground-500">{item.date}</span>
                      </div>
                      <p className="text-sm text-foreground-300 leading-relaxed">{item.content}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}